import React, { useEffect } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import Styles from '../lib/Styles';
import classes from './SelectBoxedField.module.scss';

export const distanceArray: Array<any> = [
  { value: "1", zoom: "14" },
  { value: "5", zoom: "12" },
  { value: "10", zoom: "11" },
  { value: "25", zoom: "9" },
  { value: "50", zoom: "8" },
  { value: "100", zoom: "7" }
];

export default function SelectDistance(props: any) {
  const { selectedDistance, setSelectedDistance, onChangeDistance, readOnly = false, required = false } = props;
  let initialValue = React.useRef(props.initialValue);
  const cx = new Styles(classes).cx;

  useEffect(() => {
    if (initialValue.current) {
      const indexDistance = distanceArray.findIndex((distance) => distance.value === '' + initialValue.current);
      if (indexDistance >= 0) {
        const distance = distanceArray[indexDistance];
        setSelectedDistance(distance);
      }
      initialValue.current = undefined;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDistance, setSelectedDistance, distanceArray])

  return (
    <div className={cx('root')}>
      <Autocomplete
        disabled={readOnly || (!distanceArray || distanceArray.length === 0)}
        options={distanceArray}
        getOptionLabel={(option: any) => {
          return (option && option.value) ? option.value : ''
        }
        }
        value={selectedDistance || null}
        filterSelectedOptions
        onChange={onChangeSelectedDistance}
        renderInput={(params: any) => (
          <TextField
            {...params}
            variant="outlined"
            label="Radius (Miles)"
            placeholder={"Select number of miles to use for radial search."}
            fullWidth
            required={required}
          />
        )}
      />
    </div>
  );

  function onChangeSelectedDistance(event: any, value: any) {
    setSelectedDistance(value);
    onChangeDistance();
  }
}
